import React, { useState } from "react";
import OnioTabs from "../../Components/OnioTabs/index";
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { RoundedBtn, TwinTextBtn } from "../../Components/atoms/index";
import RoundedThumbSlider from "../../Components/RoundedSlider";
import "./index.css";
import Container from "@mui/material/Container";

const Climate = () => {
  const [tab, setTab] = useState<number>(0);

  const handleMenuNavigation = (ele: any, i: number) => {
    setTab(i);
  };
  return (
    <Container>
      <OnioTabs
        onClick={handleMenuNavigation}
        menu={["Living Room", "CEO’s Office", "Conference Room", "Lobby"]}
      />
      <Box sx={{ mt: 10, mb: 5 }}>
        <Grid container sx={{ textAlign: "center" }} spacing={3}>
          {/* first gird */}
          <Grid
            xs={12}
            md={3}
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <div>
              <Typography sx={{ color: "#909090", fontSize: "18px" }}>
                CLIMATE
              </Typography>
              <div className="grid-boxes">
                <Box sx={{ mt: 3 }}>
                  <TwinTextBtn>
                    <Typography sx={{ color: "#909090", fontSize: "12px" }}>
                      ECO MODE
                    </Typography>
                    <Typography
                      sx={{
                        color: "#FFFFFF",
                        fontSize: "18px",
                        m: 1,
                      }}
                    >
                      On
                    </Typography>
                  </TwinTextBtn>
                </Box>
                <Box sx={{ mt: 3 }}>
                  <TwinTextBtn>
                    <Typography sx={{ color: "#909090", fontSize: "12px" }}>
                      FAN
                    </Typography>
                    <Typography
                      sx={{
                        color: "#FFFFFF",
                        fontSize: "18px",
                        m: 1,
                      }}
                    >
                      Light
                    </Typography>
                  </TwinTextBtn>
                </Box>
                <Box sx={{ mt: 3 }}>
                  <TwinTextBtn>
                    <Typography sx={{ color: "#909090", fontSize: "12px" }}>
                      Timer
                    </Typography>
                    <Typography
                      sx={{
                        color: "#FFFFFF",
                        fontSize: "18px",
                        m: 1,
                      }}
                    >
                      30 min
                    </Typography>
                  </TwinTextBtn>
                </Box>
                <Box sx={{ mt: 3 }}>
                  <TwinTextBtn>
                    <Typography sx={{ color: "#909090", fontSize: "12px" }}>
                      SWING
                    </Typography>
                    <Typography
                      sx={{
                        color: "#FFFFFF",
                        fontSize: "18px",
                        m: 1,
                      }}
                    >
                      ON
                    </Typography>
                  </TwinTextBtn>
                </Box>
              </div>
            </div>
          </Grid>
          {/* second grid meter grid */}
          <Grid
            className="gridBot"
            xs={12}
            md={6}
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <RoundedThumbSlider />
          </Grid>
          {/* third grid */}
          <Grid
            xs={12}
            md={3}
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <div>
              <Typography sx={{ color: "#909090", fontSize: "18px" }}>
                FUNCTIONS
              </Typography>
              <div className="grid-boxes">
                <Box sx={{ mt: 3 }} className="items">
                  <RoundedBtn>
                    <Typography sx={{ fontSize: "16px" }}>ECO MODE</Typography>
                  </RoundedBtn>
                </Box>
                <Box sx={{ mt: 3 }} className="items">
                  <RoundedBtn>
                    <Typography sx={{ fontSize: "16px" }}>HEAT</Typography>
                  </RoundedBtn>
                </Box>
                <Box sx={{ mt: 3 }} className="items">
                  <RoundedBtn>
                    <Typography sx={{ fontSize: "16px" }}>DRY</Typography>
                  </RoundedBtn>
                </Box>
                <Box sx={{ mt: 3 }} className="items">
                  <RoundedBtn>
                    <Typography sx={{ fontSize: "16px" }}>AUTO</Typography>
                  </RoundedBtn>
                </Box>
                <Box className="items" sx={{ mt: 3 }}>
                  <TwinTextBtn sx={{ backgroundColor: "#2ED23E" }}>
                    <Typography
                      sx={{
                        color: "#3E3E3E",
                        fontSize: "12px",
                      }}
                    >
                      Power
                    </Typography>
                    <Typography
                      sx={{
                        color: "#FFFFFF",
                        fontSize: "18px",
                        m: 1,
                      }}
                    >
                      On
                    </Typography>
                  </TwinTextBtn>
                </Box>
              </div>
            </div>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default Climate;
